var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 0H1.875C1.37848 0.00246417 0.902995 0.200799 0.551897 0.551897C0.200799 0.902995 0.00246417 1.37848 0 1.875V15.375C0.00246417 15.8715 0.200799 16.347 0.551897 16.6981C0.902995 17.0492 1.37848 17.2475 1.875 17.25H18.375C18.8715 17.2475 19.347 17.0492 19.6981 16.6981C20.0492 16.347 20.2475 15.8715 20.25 15.375V1.875C20.2475 1.37848 20.0492 0.902995 19.6981 0.551897C19.347 0.200799 18.8715 0.00246417 18.375 0ZM18 2.25V5.25H2.25V2.25H18ZM2.25 7.5H6.75V15H2.25V7.5ZM9 15V7.5H18V15H9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIcon01);
export default __webpack_public_path__ + "static/media/sidebar-icon-01.c971aa68200529e0e3bca3b78f13bd5e.svg";
export { ForwardRef as ReactComponent };